import { Card as MuiCard } from '@material-ui/core'
import { Link as GatsbyLink } from 'gatsby'
import styled from 'styled-components'

export const Card = styled(MuiCard)`
  padding: 24px;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: none;
  flex-direction: column;
  gap: 32px;
  border: 1px solid ${({ theme }) => theme.colors.coolGray.cool200};

  @media (min-width: 1024px) {
    flex-direction: row;
    gap: 24px;
    border-radius: 4px;
    padding: 32px 40px 32px 40px;
  }
`

export const CurrentTierHeaderSection = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;

  @media (min-width: 1024px) {
    width: 35%;
  }
`

export const Link = styled(GatsbyLink)`
  color: ${({ theme }) => theme.colors.royalBlue.shade500};
`

export const CurrentTierSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const SalesOverview = styled.h4`
  font-size: 28px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 8px;
`

export const UnlockTierText = styled.span`
  font-size: 20px;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const TierInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 15px;
`

export const TierInfoItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
`

export const TierInfoValue = styled.span`
  font-size: 18px;
  font-weight: bold;
  line-height: 18px;
  min-width: 70px;
  font-family: ${({ theme }) => theme.fonts.global.headers};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const TierInfoLabel = styled.span`
  width: 100%;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.fonts.global.body};

  @media (min-width: 1024px) {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`

export const TierLine = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.coolGray.cool200};
  width: 100%;
`
